import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import {
  makeStyles,
  createStyles,
  Grid,
  Typography,
  Button,
} from '@material-ui/core';
import BottomDrawerLayout, {
  DrawerSnapType,
} from '../../bottom-drawer-layout/BottomDrawerLayout';
import ExclamationIcon from '../../../../../static/exclamationIcon.svg';
import { useTranslation } from '../../../../../hooks/useTranslation';
import colors from '../../../../../themes/main-colors';
import { Shadow } from '../../../../../constants/shadow';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles(() =>
  createStyles({
    bottomSheet: {
      padding: '20px 20px 0',
      paddingTop: 0,
    },

    titleSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    outageTypeHeader1: {
      marginTop: '1rem',
      letterSpacing: '0px',
    },

    outageTypeStyling: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    outageTypeContentMargin: {
      marginRight: '1rem',
      marginLeft: '1rem',
      width: '90%',
    },

    cancelButton: {
      color: colors.brightBlue,
      textAlign: 'center',
      marginTop: '2rem',
      textDecoration: 'underline',
      width: '100%',
    },

    outageTypeSection: {
      backgroundColor: colors.modalBackgroundColor,
      margin: '0rem 1rem',
      boxShadow: Shadow.ONE,
      maxHeight: '30vh',
      height: 'auto',
      cursor: 'pointer',
      width: 'auto',
      borderRadius: '5px',
      marginTop: '1.5rem',
      paddingBottom: '1px',
      '&:hover': {
        border: `1.5px solid ${colors.sparkBlue}`,
      },
    },
  }),
);

export interface Props {
  open: boolean;
  onClose: () => void;
  name: string;
  onClick: (type: string) => void;
}

const { t, richT } = useTranslation();
const OutageTypeMob: FC<Props> = ({ onClose, name, onClick }: Props) => {
  const classes = useStyles();
  return (
    <BottomDrawerLayout
      onClose={onClose}
      data-testid={'notification-options'}
      refId={0}
      defaultSnap={DrawerSnapType.default}
    >
      <Box component="div" className={classes.bottomSheet}>
        <Grid className={classes.titleSection}>
          <ExclamationIcon />
          <Typography style={{ marginTop: '1rem' }} variant={'h3'}>
            {t('HELLO')} {`${name},`}
          </Typography>
          <Typography
            variant={'subtitle1'}
            className={classes.outageTypeHeader1}
          >
            {richT('ARE_YOU_EXPERIENCING_DIM_OR_FLICKERING_LIGHTS')}
          </Typography>
        </Grid>

        <Box
          className={classes.outageTypeSection}
          onClick={() => {
            onClick('fullOrPartialOutageMob');
          }}
        >
          <div className={classes.outageTypeStyling}>
            <div>
              <img
                style={{
                  maxWidth: '80%',
                  maxHeight: '80%',
                  paddingTop: '10px',
                }}
                src={require('../../../../../images/FullOrPartialOutage.svg')}
                alt="FullOrPartialOutageImage"
              />
            </div>
            <div>
              <Typography variant={'subtitle1'}>
                {richT('FULL_OR_PARTIAL_OUTAGE')}
              </Typography>
            </div>
            <div>
              <ChevronRightIcon />
            </div>
          </div>
          <Typography
            variant={'subtitle1'}
            className={classes.outageTypeContentMargin}
          >
            {richT('FULL_OR_PARTIAL_OUTAGE_CONTENT')}
          </Typography>
        </Box>
        <Box
          className={classes.outageTypeSection}
          onClick={() => {
            onClick('dimOrFlickeringMob');
          }}
        >
          <div>
            <div className={classes.outageTypeStyling}>
              <div>
                <img
                  style={{
                    maxWidth: '80%',
                    maxHeight: '80%',
                    paddingTop: '10px',
                  }}
                  src={require('../../../../../images/DimOrFlickering.svg')}
                  alt="DimOrFlickeringImage"
                />
              </div>
              <div>
                <Typography variant={'subtitle1'}>
                  {richT('DIM_OR_FLICKERING_LIGHTS')}
                </Typography>
              </div>
              <div>
                <ChevronRightIcon />
              </div>
            </div>
            <div>
              <Typography
                variant={'subtitle1'}
                className={classes.outageTypeContentMargin}
              >
                {richT('DIM_OR_FLICKERING_LIGHTS_CONTENT')}
              </Typography>
            </div>
          </div>
        </Box>
        <Box>
          <Button
            className={classes.cancelButton}
            disableRipple={true}
            onClick={onClose}
          >
            <Typography variant={'h4'} noWrap>
              {t('CANCEL')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </BottomDrawerLayout>
  );
};

export default OutageTypeMob;
